import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=295eec94&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=ts"
export * from "./transfer.vue?vue&type=script&lang=ts"
import style0 from "./transfer.vue?vue&type=style&index=0&id=295eec94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295eec94",
  null
  
)

export default component.exports